export enum RejectionType {
  HealthRejected = 'health_rejected',
  LocationRejected = 'location_rejected',
}
